module.exports = __webpack_public_path__ + "static/img/cajamitras.accf66e9.svg";